import { DATA_UNITS } from './BusinessOverview/Enums';

const convertMB = (units, amount) => {
  let convertedAmount = amount;

  if (units === DATA_UNITS.MB) {
    const [amountBeforeDot] = amount.toString().split('.');

    if (amountBeforeDot.length <= 3) {
      convertedAmount = parseFloat(convertedAmount);
    } else if (amountBeforeDot.length >= 4 && amountBeforeDot.length <= 6) {
      return convertMbTo(DATA_UNITS.GB, convertedAmount);
    } else {
      return convertMbTo(DATA_UNITS.TB, convertedAmount);
    }
  }

  return {
    amount: convertedAmount,
    units,
  };
};

const convertMbTo = (targetUnit, amount, currentUnit = DATA_UNITS.MB) => {
  if (currentUnit === DATA_UNITS.MB && targetUnit === DATA_UNITS.GB) {
    return {
      amount: parseFloat((parseFloat(amount) / 1024).toFixed(1)),
      units: DATA_UNITS.GB,
    };
  } else if (currentUnit === DATA_UNITS.MB && targetUnit === DATA_UNITS.TB) {
    return {
      amount: parseFloat((parseFloat(amount) / 1048576).toFixed(1)),
      units: DATA_UNITS.TB,
    };
  }
  return { amount, units: currentUnit };
};

export { convertMB, convertMbTo };
